import {
    useCallback,
} from 'react'
import {
    useQueryClient,
} from '@tanstack/react-query'

import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/Order/OrderBilling.requests'

type OrderCount = {
    orderCount: number
}

export default (id: number, options: {
    validFrom?: string,
    validTo?: string,
    openConfirmDialog?: boolean
} = {
    validFrom: null,
    validTo: null,
    openConfirmDialog: true,
}) => {
    const queryClient = useQueryClient()

    const invalidate = useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: [RequestKeys.getOrderCountForLaneFee],
        })
    }, [queryClient])

    const {
        validFrom, validTo, openConfirmDialog,
    } = options

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useRequest<OrderCount>({
        key: RequestKeys.getOrderCountForLaneFee,
        params: {
            id,
            data: {
                validTo, validFrom,
            },
        },
        requestFunc: RequestFn.getEntity(config.countOrdersWithLaneFee),
        enabled: Boolean(id) && openConfirmDialog,
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}
